import {translation} from "@/utils/translations";
import {showModalMsg} from "@/components/Modal/modalUtils";
import {backendUri} from "@/utils/settings";
import axios from "axios";

const wait = ms => new Promise(res => setTimeout(res, ms));


function handleUnknownError(error) {
    if (error.response.data.error === -20) {
        showModalMsg(translation.general.invalidToken);
    }
    else if (error.response.data.error === -24) {
        showModalMsg(translation.general.tokenExpired);
    }
    else if (error.response.data.error > 0) {
        showModalMsg(translation.general.unknownError);
        axios.post(backendUri + "api/game/ext/error-handler/", {
            "url": error.response.config.url,
            "error": error.response.data.error,
            "data": error.response.config.data,
            "status": error.response.status,
            "jwt": axios.defaults.headers.common['Authorization']
        })
            .then(() => {
            })
            .catch(() => {
            })
    }
}

const sort_by = (field, reverse, primer) => {

    const key = primer ?
        function (x) {
            return primer(x[field])
        } :
        function (x) {
            return x[field]
        };

    reverse = !reverse ? 1 : -1;

    return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
    }
}

export {
    handleUnknownError,
    wait,
    sort_by
};